import React from 'react';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

interface IApprovalTextFieldProps {
  label: string;
  color: string;
}
const ApprovalText = ({
  label,
  color
}: IApprovalTextFieldProps): JSX.Element => {
  return (
    <Box
      sx={{
        background: color,
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '194px',
        minHeight: '30px'
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Be Vietnam Pro',
          fontWeight: 400,
          fontSize: '16px',
          color: '#000000',
          textAlign: 'center'
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default ApprovalText;
